/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Rentable } from '@zcode/state-type'

/**
 * The INSTANT_TOUR_SCHEDULING feature means that a property should/probably supports instant
 * tour booking. However, it's possible that (for example):
 *
 * 1. The third-party API we rely on to get instant tour availablity for this property and to
 * book the tour is currently broken or
 * 2. The property very recently stopped supporting instant tours, and our backend hasn't noticed
 * yet (so it hasn't yet removed the INSTANT_TOUR_SCHEDULING feature from the property) or
 * 3. The property "supports" instant tour booking, but doesn't have any available dates/times at
 * the moment
 *
 * The way to find out *for sure* whether a property supports instant tours is to call the
 * `/api/t/1/tour_integration/:group_id` endpoint.
 *
 * The only thing we use the `INSTANT_TOUR_SCHEDULING` feature for is to skip making that API call
 * for properties that lack the feature.
 */
export const mightHaveInstantTourScheduling = (
  t: Rentable
): Rentable['mightHaveInstantTourScheduling'] =>
  !!t.features?.includes(PropertyFeatures.INSTANT_TOUR_SCHEDULING)
